<div class="d-flex flex-column h-100" id="attractorLoop">
  <!-- Main section -->

  <section *ngIf="tabIndex === 0" class="main_section al_storepromo">
    <!-- Attractor Loop Group Tab -->
    <div *ngIf="tabIndex === 0" id="attractorLoopContentGroups">
      <div id="attractorLoopMainSection" class="main_section_headers">
        <svg class="header_icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.0005 5.25C3.033 5.25 2.25 6.033 2.25 7.0005V16.9995C2.25 17.967 3.033 18.75 4.0005 18.75H13.9995C14.967 18.75 15.75 17.967 15.75 16.9995V7.0005C15.75 6.033 14.967 5.25 13.9995 5.25H4.0005ZM0.75 7.0005C0.75 5.205 2.205 3.75 4.0005 3.75H13.9995C15.795 3.75 17.25 5.205 17.25 7.0005V16.9995C17.25 18.795 15.795 20.25 13.9995 20.25H4.0005C3.13841 20.25 2.31164 19.9075 1.70205 19.298C1.09246 18.6884 0.75 17.8616 0.75 16.9995V7.0005Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M16.8765 8.47567L21.0285 6.06817C21.0998 6.02518 21.1812 6.00162 21.2645 5.99983C21.3478 5.99805 21.4301 6.0181 21.5032 6.058C21.5763 6.0979 21.6377 6.15625 21.6813 6.22724C21.7248 6.29824 21.749 6.37941 21.7515 6.46267V17.5387C21.7515 17.8807 21.3615 18.1282 21.0285 17.9347L16.878 15.5272L16.125 16.8247L20.2755 19.2322C21.564 19.9792 23.2515 19.0897 23.2515 17.5387V6.46267C23.2515 4.91317 21.564 4.02367 20.2755 4.77067L16.1265 7.17817L16.8795 8.47567H16.8765Z" />
        </svg> <span i18n="@@attractor-loop.group-tab.attract-loop">ATTRACT LOOP VIDEO</span>
      </div>

      <!-- Data header with info like no. of content groups, action buttons and filters -->
      <div id="attractorLoopDataHeader" class="data_header" [ngClass]="(displayAttractorLoop?.length > 0)?'':'display-block'">
        <span *ngIf="displayAttractorLoop?.length > 0">
          <span *ngIf="displayAttractorLoop && displayAttractorLoop?.length == 1" id="dataTitle">{{displayAttractorLoop?.length}}
            {{attractLoopVideoLabel}}</span>
            <span *ngIf="displayAttractorLoop && displayAttractorLoop?.length > 1" id="dataTitle">{{displayAttractorLoop?.length}}
              <span i18n="@@attractor-loop.data-header.attract-loop">Attract Loop Videos</span></span>
          <span *ngIf="displayAttractorLoop?.length > 1">
            <span class="sort-by-label" i18n="@@attractor-loop.data-header.sort">Sort by</span>:&nbsp;
            <div id="attractorLoopDropDown" ngbDropdown class="btn-group">
              <button ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle" id="sortDropDown">{{sortValue}}
              </button>
              <div id="attractorLoopDropDownMenu" class="sort-dropdown" ngbDropdownMenu aria-labelledby="sortDropDown">
                <button ngbDropdownItem *ngIf="sortValue!=createdDateVal" (click)="sortByDate()">{{createdDateVal}}</button>
                <button ngbDropdownItem *ngIf="sortValue!=groupNameVal" (click)="sortByName()"><span i18n="@@attractor-loop.dropdown.group">Group
                    Name</span></button>
              </div>
            </div>
          </span>
        </span>
        <span *ngIf="displayAttractorLoop?.length === 0"><span i18n="@@attractor-loop.data-header.upload">Upload a short
            video to play during the Attract Loop that
            triggers when a device is idle.</span></span>
        <span class="data_action">
          <button type="button" id="uploadpromo" class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryAttractorLoopCreateAttractorLoop"
            (click)="createNewAttractLoop()">
            <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
            <span i18n="@@attractor-loop.upload.new-attract">New Attract Loop Video</span>
          </button>
        </span>
      </div>

      <!-- Data Content -->
      <div id="attractorLoopDataContent" class="data_content segments_only" *ngIf="displayAttractorLoop?.length > 0">
        <div class="accordion" id="logoContentAccordian">
          <!-- Group 1 -->
          <div id="attractorLoopCard" class="card"
          *ngFor="let attractorLoop of displayAttractorLoop | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
            <div id="attractorLoopCardHeader" class="card-header small_text" id="segmentOne">
              <div id="attractorLoopCardHeaderContent" class="card-header-content">
                <div id="attractorLoopTitle" class="title_left">
                  <div id="attarctorSection" class="d-flex">
                    <div id="attractorTitle" class="title">
                      <span>{{attractorLoop?.configurations?.publishedName}} &nbsp;&nbsp;</span>
                    </div>
                  </div>
                  <div class="d-flex">
                  <div *ngIf="(attractorLoop.isContentExpires)" id="contentExpire" class="content-expire"><img class="contents-info-icon" alt="info_icon"><span>{{globConstant.CONT_GRP_EXPIRED_TEXT}}</span></div>
                  <div id="attractorLoopBtnGrp" class="d-flex">
                    <button type="button" placement="bottom" ngbTooltip={{editTooltipLabel}} (click)="editAttractorLoop(attractorLoop?.id)"
                      class="btn gtmEditSegment">
                      <img  alt="Edit" />
                    </button>
                    <button type="button" placement="bottom" ngbTooltip={{deleteTooltipLabel}}
                    (click)="openDeleteModal(attractorLoop?.id)" class="btn gtmDeleteSegment">
                      <img alt="Delete" />
                    </button>
                    <iposcen-delete-popup #deleteModal [contentName]="attractorLoopToDeleteName" [buttonName]="'Attract Loop Video'"
                      (delete)="deleteAttractorLoop(attractorLoopToDelete)">
                    </iposcen-delete-popup>
                  </div>
                </div>
                </div>
                <div id="otherData" class="other_data">
                  <div id="assestID">
                    <iposcen-assetid-copy [assetID]="attractorLoop?.id"></iposcen-assetid-copy>
                    <div id="attractorLoopSubtitle" class="subtitle_group">
                      <span class="subtitle"><span i18n="@@attractor-loop.subtitle_group.create">Created By</span>:
                        {{attractorLoop?.createdByUser}}</span>
                      <span class="subtitle"><span i18n="@@attractor-loop.subtitle_group.last-edited">Last Edited
                          By</span> {{attractorLoop?.createdByUser}}:
                          {{attractorLoop?.updateTime | dateFormat: "changeToLocalTimeZone"}}
                      </span>
                      <span *ngIf="userRole !== 'nonConnectedUser'" class="subtitle" i18n="@@price-content.group-tab.pushed">Pushed to all devices:
                        {{attractorLoop?.ispushedToDevice ? labelY : labelN}}</span>
                        <span *ngIf="attractorLoop?.configurations?.internalName" class="subtitle"><span>{{internalName}}:</span>
                        {{attractorLoop?.configurations?.internalName}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div id="attractorCollapse" class="collapse_link collapsed collapse-button {{attractorLoop?.id}}" type="button"
                (click)="getDetailsOfAttractorLoop(attractorLoop?.id)"
                [ngClass]="attractorLoop.isExpanded ? 'transform-180' : ''">
                <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                </svg>
              </div>
            </div>
            <div id="collapseThree" class="collapse" #collapse="ngbCollapse" [(ngbCollapse)]="!attractorLoop.isExpanded"
              aria-labelledby="logoCGThree" data-parent="#logoContentAccordian">
              <div id="attractorLoopCardBody" class="card-body card-body-asset">
                <div id="cardBodyRow" class="row">
                  <!-- Video part Start -->
                  <div id="cardBodyCol" class="col-md-3">
                    <div id="attractorLoopTable" class="preview_attract">
                      <div id="attractorLoopTableHeading" class="main_heading" scope="col"><span i18n="@@attractor-loop.table.upload" class="font-weight-bold">Uploaded Video</span></div>
                      <div id="attractorLoopConfig" class="mb-2">{{attractorLoop?.configurations?.uploadedVideoName}}</div>
                      <div id="attractorLoopConfigMini" class="mini-preview-container">
                        <div id="livePreview">
                          <iposcen-live-preview [data]="loadMiniPreview(attractorLoop.id)">
                          </iposcen-live-preview>
                        </div>
                      </div>
                  </div>
                  </div>
                  <!-- Video part End -->
                  <!-- IIT2-4663-->
                  <div id="column" class="column col-md-4" *ngIf="attractorLoop?.configurations?.publishTime && attractorLoop?.configurations?.expireTime">
                    <div id="publishTime" class="pb-4">
                      <span i18n="@@price-content.group-tab.publish-date-time" class="font-weight-bold">Publishing Date and
                      Time</span>
                      <div id="publishTime">{{attractorLoop?.configurations?.publishTime | dateFormat: "24hrP"}}</div>
                    </div>
                    <div id="expirationTime">
                      <span i18n="@@price-content.group-tab.expiration-date-time" class="font-weight-bold">Expiration Date
                        and Time</span>
                        <div>{{attractorLoop?.configurations?.expireTime | dateFormat: "24hrP"}}</div>
                    </div>
                  </div>
                  <!-- IIT2-4663-->
                  <!-- Form Factor Start -->
                  <div id="previewAttractCol" class="col-md-5">
                   <div id="previewAttract" class="preview_attract">
                    <div id="previewAttractHeading" class="main_heading" scope="col"><span i18n="@@banner-carousel.content-group-applies-to" class="font-weight-bold">Content Group
                      Applies
                      To</span>: </div> 
                    <div id="previewAttractDevices"><strong><span>{{globConstant.DEVICE_TYPES}}</span>: </strong>
                        {{ attractorLoop?.configurations?.formFactor?.devices.length ? attractorLoop?.configurations?.formFactor?.devices : globConstant.ALL}}
                    </div>
                    <div id="previewAttractManufactures"><strong><span>{{globConstant.MANUFACTURERS}}</span>:</strong>
                        {{ attractorLoop?.configurations?.formFactor?.manufacturer.length ?
                        attractorLoop?.configurations?.formFactor?.manufacturer : globConstant.ALL}}
                    </div> 
                    <div id="previewAttractProcessors"><strong><span>{{globConstant.PROCESSORS}}</span>: </strong>
                      {{ attractorLoop?.configurations?.formFactor?.processors.length ? attractorLoop?.configurations?.formFactor?.processors :
                        globConstant.ALL}}
                    </div>
                    <div id="previewAttractGenerations"><strong><span>{{globConstant.GENERATIONS}}</span>:</strong>
                      {{ attractorLoop?.configurations?.formFactor?.generations.length ? attractorLoop?.configurations?.formFactor?.generations :
                        globConstant.ALL}}
                    </div>
                  </div>
                  </div>
                  <!-- Form Factor End -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Data Footer - Pagination -->
      <div id="dataFooter" class="data_footer">
        <nav aria-label="attractor loop content pagination" *ngIf="displayAttractorLoop?.length > 0">
          <ngb-pagination [collectionSize]="displayAttractorLoop?.length" [(page)]="page" [pageSize]="pageSize"
            [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
        </nav>
      </div>

    </div>
  </section>
  <section *ngIf="tabIndex === 1 || tabIndex === 2" class="main_section_with_preview">
    <ng-container>
      <div id="createAttractorLoop" *ngIf="tabIndex === 1">
        <iposcen-create-attractor-loop (goBacktoAttractorLoop)="setCreatedGrpID($event)"
          (refreshAttractorLoopdata)="refreshAttractorLoopdata()"></iposcen-create-attractor-loop>
      </div>
    </ng-container>

  </section>
</div>
